import React, { useEffect, useState } from "react";
import {
  CancelButton,
  UpdateButton,
} from "../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Box, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  getAllBrandsList,
  getAllCategoryNoLimit,
  getAllProducts,
  updateProduct,
} from "../../../redux/features/assetManagementSlice";

const EditProduct = ({ rowData, dispatchParams }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading, categoryAllData, brandDataList } = useSelector(
    (state) => state.assetmanagement
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      product_name: rowData.product_name,
      category_id: rowData.category_id,
      brand_id: rowData.brand_id,
      // stock_quantity: rowData.stock_quantity,
      // purchase_price: rowData.purchase_price,
      // sale_price: rowData.sale_price,
      description: rowData.description,
      product_id: rowData.product_id,
      // product_status: rowData.product_status,
      // minimum_stock_quantity: rowData.minimum_stock_quantity,
      // product_serial_number: rowData.product_serial_number,
    },
    onSubmit: (values) => {
      dispatch(updateProduct({ data: [values] })).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getAllProducts(dispatchParams));
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  useEffect(() => {
    dispatch(getAllCategoryNoLimit());
  }, []);

  useEffect(() => {
    dispatch(getAllBrandsList());
  }, []);

  const productStatusDemo = [
    { id: 0, name: "Active" },
    { id: 1, name: "Inactive" },
  ];
  return (
    <GlobalDialog
      title={"Update Product"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      popupButton={
        <UpdateButton size="medium" action={() => setOpen(true)}>
          Update
        </UpdateButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <TextField
                    name="product_name"
                    value={formik.values.product_name}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Product Name"
                  />
                  {/* <TextField
                    type="number"
                    name="stock_quantity"
                    value={formik.values.stock_quantity}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Stock Quantity"
                  /> */}
                  {/* <TextField
                    type="number"
                    name="purchase_price"
                    value={formik.values.purchase_price}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Purchase Price"
                  />
                  <TextField
                    type="number"
                    name="sale_price"
                    value={formik.values.sale_price}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Sale Price"
                  /> */}
                  <TextField
                    name="description"
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Description"
                  />
                  {/* <TextField
                    name="minimum_stock_quantity"
                    value={formik.values.minimum_stock_quantity}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Minimum stock quantity"
                  />
                  <TextField
                    name="product_serial_number"
                    value={formik.values.product_serial_number}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Product serial number"
                  /> */}
                  <GlobalSelectField
                    options={{
                      formik,
                      name: "category_id",
                      label: "Category",
                      data: categoryAllData.data,
                      keys: {
                        id: "category_id",
                        value: "category_name",
                      },
                    }}
                  />
                  <GlobalSelectField
                    options={{
                      formik,
                      name: "brand_id",
                      label: "Brand",
                      data: brandDataList.data,
                      keys: {
                        id: "brand_id",
                        value: "brand_name",
                      },
                    }}
                  />
                  {/* <GlobalSelectField
                    options={{
                      formik,
                      name: "product_status",
                      label: "Status",
                      data: productStatusDemo,
                      keys: {
                        id: "id",
                        value: "name",
                      },
                    }}
                  /> */}
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <UpdateButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Update"}
                    </UpdateButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default EditProduct;
